<label for="typeahead-related-products">
  <h5 translate>SPARE_PARTS</h5>
</label>
<input
  id="typeahead-related-products"
  type="text"
  class="form-control"
  [resultFormatter]="formatterRelatedProducts"
  [(ngModel)]="modelRelatedProduct"
  [ngbTypeahead]="searchRelatedProducts"
  (selectItem)="onRelatedProductSelect($event)"
/>
<div class="row" *ngIf="pimProduct.extra.pim.spareParts">
  <div class="col-xs-12 col-sm-6 pt-2" *ngFor="let relatedProductId of pimProduct.extra.pim.spareParts.split(',')">
    <div class="input-group">
      <input type="text" disabled="disabled" class="form-control input-sm" [value]="relatedProductId" />
      <button type="button" class="btn btn-danger" (click)="removeRelatedProduct(relatedProductId)" translate>
        DELETE
      </button>
    </div>
  </div>
</div>
